<template>
<div class="header-bottom">
    <div class="container">
        <div class="row">
            <div class="col-sm-9">
                <div class="container">
                    <nav class="navbar navbar-inverse">
                        <div class="navbar-header">
                            <button class="navbar-toggle" type="button" data-toggle="collapse" data-target="#js-navbar-collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="sr-only">Toggle navigation</span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                        </div>
                        <div class="collapse navbar-collapse" id="js-navbar-collapse">
                            <ul class="nav navbar-nav mr-auto">
                                <li class="nav-item"><router-link to="/" class="nav-link">Home</router-link></li>
                                <template v-for="navigation in topNavigation">
                                  <navigation-item :navigationItem="navigation" v-bind:key="navigation.contentPageId" ></navigation-item>
                                </template>
                                <li class="nav-item"><a target="_new" :href="eBayUrl" class="nav-link">Online Shop</a></li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
            <div class="col-sm-3">
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NavigationItem from './NavigationItem';
import { EBAY_SHOP_URL } from '../../config';

export default {
  name: 'top-navigation',
  created() {
    if (this.topNavigation.length === 0) {
      this.$store.dispatch('getNavigation');
    }
  },
  computed: {
    topNavigation() {
      return this.$store.getters.getTopNavigation;
    },
  },
  data() {
    return {
      eBayUrl: EBAY_SHOP_URL,
    };
  },
  components: {
    'navigation-item': NavigationItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/TopNavigation.vue